/**
 * User-facing compliance file name (display + download).
 * Strips internal version segments, e.g. `1.2.3_2.png` → `1.2.3.png`.
 */
export function formatComplianceFileName(fileName: string): string {
  if (!fileName?.trim()) {
    return fileName ?? '';
  }
  let name = fileName.replace(/_V\d+_.*?_/g, '_');
  name = name.replace(/_(\d+)(\.[^.]+)$/i, '$2');
  return name;
}
